<template>
  <div>
    <v-navigation-drawer v-model="drawer" color="grey darken-3" app right>
      <v-list dense>
        <v-list-item
          v-if="!me.employee_number"
          :to="{
            name: 'user.index',
            params: { id: me.providers[0].id, userId: me.id }
          }"
        >
          <v-list-item-action>
            <v-icon color="white">mdi-key-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text text--darken-1"
              >Alterar Senha</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-divider class="menu-divider" color="white"></v-divider>
        <v-list-item link class="menu-versao">
          <v-list-item-content>
            <v-list-item-title class="white--text">
              <p class="texto-versao">v{{ version }}</p>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="handlerLogout" class="menu-sair">
          <v-list-item-action>
            <v-icon color="white">icon-sair</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text text--darken-1">
              Sair
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="#007BC3" app dark>
      <router-link to="/">
        <v-icon class="iconSebrae" size="45px">icon-pfo</v-icon>
        <span class="iconSebrae"></span>
      </router-link>
      <v-spacer></v-spacer>

      <v-icon class="iconSebrae">icon-marca_dagua</v-icon>
      <span class="iconSebrae"></span>

      <v-spacer></v-spacer>

      <Communication v-if="verifyAuth(me)" />

      <Avatar v-if="verifyAuth(me)" />

      <v-toolbar-title style="font-size: 15px">{{
        me.name ? me.name : me.providers[0].trade_name
      }}</v-toolbar-title>

      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import Communication from "./Communication";
import Avatar from "./avatarWithNotifications";
export default {
  components: {
    Communication,
    Avatar
  },
  data: () => ({
    drawer: false,
    group: null,
    version: process.env.VUE_APP_VERSION
  }),
  computed: {
    ...mapGetters({
      me: "$_auth/me"
    })
  },
  methods: {
    async handlerLogout() {
      var response = await this.logout();
      if (response.code == 200) {
        window.location.href = "/autenticacao";
        this.$store.commit("$_auth/DELETE_ME_AUTHENTICATED");
      }
    },

    ...mapActions({
      logout: "$_auth/logout"
    }),

    verifyAuth(me) {
      if (_.hasIn(me, "id") && !this.me.password_reset) return true;
      else return false;
    }
  }
};
</script>

<style lang="scss">
.icon-marca_dagua {
  font-size: 68px !important;
  left: 1.54%;
  right: 85.43%;
  top: 0%;
  bottom: 2.25%;
  font-size: 65px;
}

.menu-versao {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 50%;
  text-align: center;

  cursor: default;
}

.icon-gfs {
  font-size: 100px !important;
  left: 0%;
  right: 85.43%;
  top: 0%;
  bottom: 2.25%;
  font-size: 65px;
}

.menu-divider {
  width: 85%;
  margin: 10px auto;
}

.menu-sair {
  margin-left: 25px;
}
</style>
